import { TextComponent } from "../../../components";
import { SubContacts } from "../../ClientScreens";
import styles from "./ProfileSubVendors.module.css";

const ProfileSubVendors = () => {
  return (
    <>
      <TextComponent textClass={styles.heading}>Staff</TextComponent>
      <SubContacts />
    </>
  );
};

export default ProfileSubVendors;
